<template>
  <component
    :is="link ? 'SfLink' : 'button'"
    class="relative flex items-center justify-center cursor-pointer whitespace-nowrap"
    :class="[
      'ex-button',
      {
        'is-disabled--button': buttonActive(link, disabled),
        'is-disabled--link': linkActive(link, disabled),
      },
    ]"
    :aria-disabled="disabled"
    :link="link"
    v-bind="$attrs"
    :disabled="disabled"
  >
    <slot />
  </component>
</template>
<script>

import { focus } from '~/directives/focus/focus';
import SfLink from '~/components/atoms/SfLink/SfLink.vue';
export default {
  name: 'SfButton',

  components: {
    SfLink,
  },

  directives: {
    focus,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    link: {
      type: [String, Object],
      default: null,
    },
  },
  methods: {
    linkActive(link, disabled) {

      return link && disabled;

    },
    buttonActive(link, disabled) {

      return !link && disabled;

    },
  },
};

</script>
